import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

import * as I from 'interfaces';

import {useInputMenuContext} from 'context/InputMenu';
import DeleteActionButton from 'components/InputMenu/DeleteActionButton';
import Divider from '@mui/material/Divider';
import {useTranslation} from 'react-i18next';
import {type Dispatch, type SetStateAction} from 'react';
import {Stack, styled} from '@mui/material';

const deleteActions = [I.FormSelectionEnum.cage, I.FormSelectionEnum.site];

const InputActionButtons = ({
  setCreateUpdateInput,
  onSubmit,
  disabled,
  loading,
}: {
  setCreateUpdateInput?: Dispatch<SetStateAction<boolean>>;
  disabled?: boolean;
  loading?: boolean;
  onSubmit?: () => void;
}) => {
  const {t} = useTranslation('common');

  const inputContext = useInputMenuContext();
  const inputMenuDispatch = inputContext?.dispatch;
  const inputMenuState = inputContext?.state;
  const method = inputMenuState?.method;
  const displayDeleteButton = inputMenuState?.form && deleteActions.includes(inputMenuState?.form);

  return (
    <Root>
      <Divider />
      <Stack direction="row" justifyContent="space-between" spacing={2} paddingTop={2}>
        <Button
          fullWidth={true}
          variant="contained"
          onClick={() => {
            onSubmit?.();
            setCreateUpdateInput?.(true);
          }}
          endIcon={<CheckIcon />}
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          disabled={loading || disabled}
          color="primary"
          data-testid="input-action-button-confirm"
        >
          {loading && (
            <Box marginRight={1} display="flex" justifyContent="center">
              <CircularProgress color="primary" size={24} />
            </Box>
          )}
          {t('confirm')}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            inputMenuState?.onClose && inputMenuState.onClose();
            inputMenuDispatch && inputMenuDispatch({type: I.inputMenuActionType.closeMenu});
          }}
          endIcon={<CloseIcon />}
          fullWidth={true}
        >
          {t('cancel')}
        </Button>
      </Stack>

      {method === I.methodType.edit && displayDeleteButton && (
        <Box paddingTop={2}>
          <DeleteActionButton />
        </Box>
      )}
    </Root>
  );
};

export default InputActionButtons;

const Root = styled('div')(({theme}) => ({
  width: '100%',
  left: 0,
  bottom: 0,
  zIndex: 2,
  position: 'sticky',
  backgroundColor: theme.palette.background.paper,
  paddingBottom: theme.spacing(2.4),
}));
